import React from 'react'
import "./Donatebutton.css"
const Donatebutton = () => {
  return (
    <div className='donate-button-box'>
      <button className='donate-button'>
        <a href="https://www.ketto.org/fundraiser/spreading-love-and-happiness-on-christmas-and-new-year" target={"_blank"}>&#10084;
        Donate</a>
      </button>
    </div>
  )
}

export default Donatebutton
